import * as nprogress from 'nprogress';
import EventDispatcher from 'events';

export default class CatalogAside extends EventDispatcher {
    constructor(selector, config = {}) {
        super();

        this.config = Object.assign({
            cancelTransition: false,
        }, config);
        this.widget = $(selector ? selector : '.aside.aside_left');
        if (this.widget.length === 0) {
            throw new Error('Не найден aside виджет');
        }
        this.init();
    }

    init() {
        this.widget.on('click', 'a.aside__group, a.aside__group-item', (e) => {
            if (!this.config.cancelTransition) {
                return;
            }

            let link = $(e.target).closest('a');

            e.preventDefault();
            e.stopPropagation();

            if ($(e.target).hasClass('aside__group-item')) {
                this.widget.find('.aside__group-item').removeClass('aside__group-item_active');
                $(e.target).addClass('aside__group-item_active');
            }
            history.replaceState(null, null, link.attr('href'));
            this.emit('select');
        });

        this.widget.find('.js-clear-categories').click(() => {
            history.replaceState(null, null, location.pathname);
            this.widget.find('.aside__group-item').removeClass('aside__group-item_active');
            this.widget.find('.aside__group').removeClass('aside__group_open');
            this.emit('select');
        });

        this.initAccordions();

        $('.aside__group-name').css({
            "border-bottom": "1px solid #EBE8E7",
            "background": "white"
        });
    }

    initAccordions() {
        let _this = this;

        this.widget.on('click', '.aside__group', function (e) {
            if ($(e.target).closest('.aside__group-item')[0]) {
                return;
            }
            let el = $(this);

            if (el.hasClass('aside__group_open')) {
                el.toggleClass('aside__group_open');
            } else {
                _this.widget.find('.aside__group').removeClass('aside__group_open');
                el.addClass('aside__group_open');
            }
        });
    }

    enableSearch() {
        let searchInput = this.widget.find('.search__input');
        let timer = null;
        $("#search-aside").on('submit', (e) => {
            e.preventDefault();
            return false;
        });
        searchInput.on('input', () => {
            if (timer) {
                clearTimeout(timer);
            }
            timer = setTimeout(() => {
                nprogress.start();
                $.post({
                    url: '/ajax/search',
                    data: searchInput.parent().serialize()
                }).done((response) => {
                    let newContent = $(response['html']).html();
                    history.replaceState(null, null, CatalogAside.addGet(
                        document.location.origin + document.location.pathname, {
                            'search': response['search']
                        }
                    ));
                    this.widget.find('.aside__scroll').html(newContent);
                }).fail((error) => {
                    console.error(error);
                }).always(() => {
                    nprogress.done();
                });
            }, 500)
        })
    }

    static serializeGet(obj) {
        let str = [];
        for (let p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    }

    static addGet(url, get) {
        if (typeof(get) === 'object') {
            get = CatalogAside.serializeGet(get);
        }

        if (url.match(/\?/)) {
            return url + '&' + get;
        }

        return url + '?' + get;
    }
}



// WEBPACK FOOTER //
// app/widgets/assets/catalog-aside/widget.js